import { Injectable } from '@angular/core';

/**
 * Singleton vanilla Logger factory
 */
@Injectable({ providedIn: 'root' })
export class IgnoreHistoryService {
  private ignoreHistory = true;
  /**
   * Set ignoreHistory flag off
   */
  off(): void {
    this.ignoreHistory = false;
  }
  /**
   * Set ignoreHistory flag on
   */
  on(): void {
    this.ignoreHistory = true;
  }
  /**
   * returns current value of ignoreHistory flag
   */
  isFlagOn(): boolean {
    return this.ignoreHistory;
  }
}
